import { render, staticRenderFns } from "./designerModal.vue?vue&type=template&id=528a2d9c&scoped=true&"
import script from "./designerModal.vue?vue&type=script&lang=js&"
export * from "./designerModal.vue?vue&type=script&lang=js&"
import style0 from "./designerModal.vue?vue&type=style&index=0&id=528a2d9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a2d9c",
  null
  
)

export default component.exports